<template>
  <v-btn
    @click="togglePinKey()"
    variant="flat"
    class="ml-3 refresh-button"
    style="height: 56px !important"
    :color="sending ? 'primary' : ''">
    <v-icon style="height: 33px; opacity: 0.7">mdi-send</v-icon>
  </v-btn>
</template>
<script setup>
import { deluge, deluge_sock } from '@/stores/deluge.js';
import { ref, defineProps } from 'vue';
const sending = ref(false);
const props = defineProps(['myKey', 'item']);
function togglePinKey() {
  sending.value = true;
  let data = {};
  data[props.myKey] = props.item.value;
  if (window.self !== window.top) {
    parent.postMessage({
      deluge_core_cmd: JSON.stringify({
        cmd: 'set_scene_data',
        data: { name: props.myKey, data: props.item.value },
      }),
    });
  } else {
    deluge_sock.value.send(
      JSON.stringify({
        cmd: 'set_scene_data',
        data: { name: props.myKey, data: props.item.value },
      })
    );
  }
  setTimeout(() => {
    sending.value = false;
  }, 200);
}
</script>
